export default __webpack_public_path__ + "static/media/adopt.632c0a85.png";